import { render, staticRenderFns } from "./FormLayout.vue?vue&type=template&id=0b9ed3ba"
import script from "./FormLayout.vue?vue&type=script&lang=js"
export * from "./FormLayout.vue?vue&type=script&lang=js"
import style0 from "./FormLayout.vue?vue&type=style&index=0&id=0b9ed3ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports